<template>
    <div class="vm-album-card flex-box flex-align-items-center pointer" @click="tap" :class="[browser_size, is_shop_type ? 'shop-type': '']">
      <template v-if="is_shop_type">
        <div class="flex-box info-box">
            <span class="lh1 mq fs-16-12 black-5">{{album.title}} {{album.post_count}}</span>
            <i class="afd afd-arrow-down black-5 fs12"></i>
        </div>
      </template>
      <template v-if="!is_shop_type">
        <pic class="cover" v-if="album.cover" :src="album.cover" width="48" height="48" />
        <div class="flex-box info-box">
            <span class="lh1 mq fs-16-12">{{album.title}}</span>
            <!-- <span class="lh1 mq fs-14-12 black-3 post-count" v-if="album.post_count > 0"> {{album.post_count}}{{$t('c.AlbumCard.text1')}}</span> -->
            <span class="lh1 mq fs-14-12 black-3 post-count gl-hover-text" @click.stop="open_dir" v-if="album.post_count > 0">{{$t('c.AlbumCard.text2')}} {{album.post_count}}</span>
        </div>
      </template>
    </div>
</template>

<script>
export default {
  props: {
    album: {},
    is_shop_type: {
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      //   n: this.browser_size == "small" ? 2 : 3
    };
  },
  computed: {},
  mounted() {},
  methods: {
    tap() {
      if(this.is_shop_type){
        this.open_dir()
        return false;
      }
      this.$mixin_router_push(`/album/${this.album.album_id}`)
    },
    open_dir() {
        this.$mixin_show_modal_album({
            album_id: this.album.album_id,
            post_count: this.album.post_count,
            is_show_unlock: this.is_shop_type ? false : true,
        });
    },
  }
};
</script>

<style lang="stylus" scoped>
.vm-album-card {
    border: 1px solid $black-1;
    box-sizing: border-box;
    border-radius: 4px;
    padding:20px;
    background:$white;

    &.shop-type{
      background: #FAFAFA;
      border-radius: 1px;
      border:0;
      .info-box{
        width:100%;
        justify-content: space-between;
        flex-direction:row;
        align-items: center;
      }
    }
    .cover{
        width:48px;
        height:48px;
        border-radius: 2px;
        margin-right:20px;
    }
    .info-box{
        flex-direction:column;
    }
    .post-count{
        margin-top:8px;
    }
    &.small {
        padding:4px 16px 4px 4px;
        &.shop-type{
          padding:12px 16px 12px 12px;
        }
        .cover{
            width:32px;
            height:32px;
            margin-right:8px;
        }
        .info-box{
            width:100%;
            justify-content: space-between;
            flex-direction:row;
            align-items: center;
        }
        .post-count{
            margin-top:0px;
        }
    }
}
</style>
